import { Component, Input, OnInit, inject } from '@angular/core';
import { AdditionalServiceMutex } from '@sales/modules/subscription/models/additional-service-voice.model';
import { PriceType } from '@shared/pipes/price-format.pipe';
import { ControlContainer, FormGroupDirective, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PriceFormatPipe } from '@app/shared/pipes/price-format.pipe';
import { IceSelectBoxComponent } from '@app/shared/components/molecules/ice-select-box/ice-select-box.component';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'app-mutex-additional-service',
  templateUrl: './mutex-additional-service.component.html',
  styleUrls: ['./mutex-additional-service.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [IceSelectBoxComponent, MatRadioGroup, MatRadioButton, FormsModule, ReactiveFormsModule, PriceFormatPipe],
})
export class MutexAdditionalServiceComponent implements OnInit {
  private formGroupDirective = inject(FormGroupDirective);

  @Input() mutexSet: AdditionalServiceMutex;
  @Input() selectionControlName: string;
  @Input() mutexControlName: string;
  selectionControl: FormControl;

  PriceType = PriceType;

  ngOnInit(): void {
    this.selectionControl = this.formGroupDirective?.form?.get(this.selectionControlName) as FormControl;
  }

  get isSelected(): boolean {
    return this.selectionControl?.value;
  }
}
